module.exports = __webpack_public_path__ + "static/media/body_part_dummy.4d9a701e.svg";